export const isEmptyString = (string?: string) =>
  !string || string?.length === 0;
